import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  schemaSecondStep,
  FormValuesSecondStep,
  inputDataProps,
  inputDataSecondStep,
  inputDataFirstStep,
} from "./LeadFormComponentConfig";
import { PrimarySubmitButton } from "@ui";
import { useNumberFormatter } from "@storeLocator/shortApp/util/useNumberFormatter";
import { zipSearch } from "@components/onlineScheduler/utils/utilFunctions";
import LeadFormSelectField from "./LeadFormSelectField";
import CustomRadioGroupButton from "./CustomRadioGroupButton";
import { Link } from "gatsby";
interface SecondStepFormProps {
  onNextStep: (data: FormValuesSecondStep, coords: any) => void;
  formData: FormValuesSecondStep;
  errorMessage: string;
}
const SecondStepForm = ({
  onNextStep,
  formData,
  errorMessage: errMessage,
}: SecondStepFormProps) => {
  const lastCallRef = useRef(0);
  const [checkboxValid, setCheckboxValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const form = useForm<FormValuesSecondStep>({
    resolver: zodResolver(schemaSecondStep),
    mode: "onChange",
    defaultValues: formData || {},
  });

  const {
    register,
    control,
    handleSubmit,
    formState,
    setValue,
    getValues,
    watch,
    setError,
  } = form;
  const { errors, isDirty, isValid, isSubmitting } = formState;

  useNumberFormatter({
    field: "CellPhone",
    formatPhone: true,
    form,
  });

  useNumberFormatter({
    field: "HomeZipcode",
    slice: 5,
    form,
    // callback: async (formattedValue) => {
    //   let newCoords = await getCoords(formattedValue);

    //   // Set an error if the coordinates are empty
    //   //   if (Object.keys(newCoords).length === 0) {
    //   //     setError("HomeZipcode", {
    //   //       type: "manual",
    //   //       message: "Please enter a valid ZIP code.",
    //   //     });
    //   //     return;
    //   //   }

    //   // Throttle the function call to only once every x seconds
    //   const now = Date.now();
    //   if (now - lastCallRef.current < 3000) {
    //     return;
    //   }

    //   lastCallRef.current = now;
    //   await getCityStateInfo(newCoords)
    //     .then((result) => {
    //       if (result) {
    //         setValue("City", result.city);
    //         setValue("State", result.state);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error handling city and state info:", error);
    //     });
    // },
  });

  // const getCoords = async (formattedValue: string) => {
  //   const newCoords = await zipSearch(formattedValue);
  //   return newCoords;
  // };
  // const extractCityState = (locationString: string) => {
  //   const cityStateRegex = /[a-zA-Z\s]+,\s([A-Z]{2})/;

  //   const cityStatePart = locationString.split(" ").slice(1).join(" ");

  //   const match = cityStatePart.match(cityStateRegex);

  //   if (match) {
  //     const city = cityStatePart.split(",")[0].trim();
  //     const state = match[1].trim();
  //     return { city, state };
  //   } else {
  //     return { city: "", state: "" };
  //   }
  // };

  // const getCityStateInfo = async (coords: any) => {
  //   if (
  //     !coords ||
  //     (Object.keys(coords).length === 0 && coords.constructor === Object)
  //   )
  //     return;

  //   try {
  //     const baseURL = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.lat},${coords.lng}&key=${process.env.GOOGLE_MAPS_API_KEY}`;

  //     const response = await fetch(baseURL);

  //     if (!response.ok) {
  //       throw new Error("Network response was not ok");
  //     }

  //     const data = await response.json();

  //     const info = extractCityState(data.plus_code.compound_code);
  //     return info;
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  // This will handle the form submission and pass data to the parent component
  const onSubmit = async (data: FormValuesSecondStep) => {
    if (checkboxValid) {
      let newCoords = await zipSearch(data.HomeZipcode);
      onNextStep(data, newCoords);
    } else {
      setErrorMessage("You need to check the checkbox before continuing");
    }
  };
  useEffect(() => {
    setErrorMessage(errMessage);
  }, [errMessage]);
  return (
    <div>
      <h2 className="text-left font-body text-[32px] font-bold leading-[32px] tracking-[0.64px] text-white md:text-[48px] md:leading-[52px] md:tracking-[0.96px]">
        Get Started
      </h2>
      {errorMessage && (
        <span className="font-body font-bold text-[#FFFCFA]">
          {errorMessage}
        </span>
      )}
      <form
        className="mt-[10px] flex flex-col"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="flex flex-wrap gap-[10px] ">
          {!!inputDataSecondStep &&
            inputDataSecondStep.map(
              ({
                name,
                placeholder,
                fieldType,
                type,
                optionData,
              }: inputDataProps) => {
                if (fieldType == "select") {
                  return (
                    <LeadFormSelectField
                      key={name}
                      {...register(name)}
                      optionData={optionData!}
                      defaultOptionText={placeholder!}
                      error={errors[name]?.message}
                    />
                  );
                } else {
                  return (
                    <div
                      key={name}
                      className="flex w-full flex-col sm:max-w-[320px]"
                    >
                      <input
                        {...register(name)}
                        type={type}
                        placeholder={placeholder}
                        className="h-[44px] rounded-[10px] border-[1px] border-solid border-white bg-transparent bg-white px-[11px] text-[14px] leading-[20px] tracking-[0.28px] outline-none placeholder:font-body placeholder:text-lightTeal"
                      />
                      <span className="pl-[2px] font-body text-[14px] font-bold text-[#FFFCFA]">
                        {errors[name]?.message}
                      </span>
                    </div>
                  );
                }
              }
            )}
        </div>
        <div className="flex flex-col gap-[30px] pb-5 pt-[15px]">
          <div className="flex items-start gap-[14px]">
            <CustomRadioGroupButton
              active={checkboxValid}
              onClick={() => setCheckboxValid(!checkboxValid)}
              className="mt-[3px] flex-shrink-0"
            />
            <span className="font-body text-sm leading-[20px] tracking-[0.28px] text-white [&_a]:underline">
              By completing submission you agree to CheckSmart{" "}
              <Link
                to="/disclosures/optional-communications/"
                title="Communication Preferences"
              >
                Communication Preferences
              </Link>{" "}
              and{" "}
              <Link
                to="https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice/"
                title="Privacy Notice"
              >
                Privacy Notice
              </Link>
            </span>
          </div>
        </div>
        <div className="mt-[20px] self-center sm:self-start">
          <PrimarySubmitButton
            externalText={"CONTINUE"}
            internalText={"SMART CHOICE"}
          />
        </div>
      </form>
      <DevTool control={control} />
    </div>
  );
};

export default SecondStepForm;
